import { inject, Injectable } from '@angular/core';
import { UntypedFormBuilder, ValidatorFn, Validators } from '@angular/forms';

import type { Observable } from 'rxjs';

import type { TypedFormControl, TypedFormGroup } from '@core/common-legacy';
import { matchingPasswords, upperLowerCase } from '@core/common-legacy';

type Admin = any;

export type AccountPasswordForm = TypedFormGroup<{
  password: TypedFormControl<string>;
  passwordConfirmation: TypedFormControl<string>;
  secureChangeToken?: TypedFormControl<string>;
  currentPassword?: TypedFormControl<string>;
}>;

export type AccountPasswordErrors = {
  required: string;
  mismatchedPasswords: string;
};

@Injectable()
export abstract class PasswordChangeService {
  protected readonly formBuilder = inject(UntypedFormBuilder);

  public errors: AccountPasswordErrors;

  public createForm(
    secureChangeToken?: string,
    requireCurrentPassword = false,
  ): AccountPasswordForm {
    const formConfig: {
      password: Array<string | ValidatorFn>;
      passwordConfirmation: Array<string | ValidatorFn>;
      currentPassword?: Array<string | ValidatorFn>;
      secureChangeToken?: string;
    } = {
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(72),
          upperLowerCase(),
          Validators.pattern('.*[0-9].*'),
        ])!,
      ],
      passwordConfirmation: ['', Validators.required],
    };

    if (requireCurrentPassword) {
      formConfig.currentPassword = ['', Validators.required];
    } else if (secureChangeToken) {
      formConfig.secureChangeToken = secureChangeToken;
    }

    return <AccountPasswordForm>this.formBuilder.group(formConfig, {
      validator: matchingPasswords('password', 'passwordConfirmation'),
    });
  }

  public abstract submit(form: AccountPasswordForm): Observable<string | Admin>;
  public abstract showSuccessNotification(): void;
}
